import { useMemo } from 'react';
import * as THREE from 'three';

const BrickWall = ({ width, position = [0, 0, 0] }) => {
  const wallHeight = 2;
  const wallWidth = width + 0.5;
  const wallDepth = 0.5;

  const createLines = () => {
    const group = new THREE.Group();
    const brickHeight = 0.1;
    const brickWidth = 0.3;

    const rows = Math.floor(wallHeight / brickHeight);
    const cols = Math.floor(wallWidth / brickWidth);

    for (let i = 0; i <= rows; i++) {
      const line = new THREE.Line(
        new THREE.BufferGeometry().setFromPoints([
          new THREE.Vector3(0, i * brickHeight, 0),
          new THREE.Vector3(wallWidth, i * brickHeight, 0),
        ]),
        new THREE.LineBasicMaterial({ color: '#000000' })
      );
      group.add(line);
    }

    for (let j = 0; j <= cols; j++) {
      const line = new THREE.Line(
        new THREE.BufferGeometry().setFromPoints([
          new THREE.Vector3(j * brickWidth, 0, 0),
          new THREE.Vector3(j * brickWidth, wallHeight, 0),
        ]),
        new THREE.LineBasicMaterial({ color: '#000000' })
      );
      group.add(line);
    }

    return group;
  };

  const frontLines = useMemo(() => createLines(), [width]);
  const backLines = useMemo(() => createLines(), [width]);

  const [x, y, z] = position;

  return (
    <>
      {/* Tuğla rengi kutu */}
      <mesh position={[x, y, z]}>
        <boxGeometry args={[wallWidth, wallHeight, wallDepth]} />
        <meshStandardMaterial color="#cc8866" roughness={1} metalness={0.2} />
      </mesh>

      {/* Ön çizgiler (hafif dışta) */}
      <primitive object={frontLines} position={[x - wallWidth / 2, y - wallHeight / 2, z + wallDepth / 2 + 0.001]} />

      {/* Arka çizgiler (hafif içte) */}
      <primitive object={backLines} position={[x - wallWidth / 2, y - wallHeight / 2, z - wallDepth / 2 - 0.002]} />
    </>
  );
};

export default BrickWall;
